import { Group, Popover, Stack } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { noop } from '@mantine/utils';
import { UserRole } from '@repo/common/enums/UserRole';
import {
	Button,
	Icon,
	IconButton,
	Switch,
	Text,
	Title,
} from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import {
	NavBarBreadcrumbWrapper,
	NavBarRightSideWrapper,
	NavBarWrapper,
} from '.';
import { Guard } from '../../Guard/Guard';
import { NewTeamModal } from '../../NewTeamModal/NewTeamModal';
import { appShellStore } from '../store';

function TeamsPageNavBar() {
	const [
		createTeamModalOpened,
		{ open: openCreateTeamModal, close: closeCreateTeamModal },
	] = useDisclosure(false);

	const {
		navBarUI: {
			teamsPage: { includeArchive },
		},
		teamsPageIncludeArchiveHandler: { toggle: toggleIncludeArchive },
	} = appShellStore;

	return (
		<>
			<NavBarWrapper>
				<NavBarBreadcrumbWrapper>
					<Title order={1} size="sm" data-testid="teams-page-nav-bar-title">
						Teams
					</Title>
				</NavBarBreadcrumbWrapper>
				<NavBarRightSideWrapper>
					<Guard v1AllowedRoles={[UserRole.ADMIN]} v2Permission="Teams.Manage">
						<Popover shadow="lg">
							<Popover.Target>
								<IconButton
									tooltip="Settings"
									iconName="adjustmentsHorizontal"
								/>
							</Popover.Target>
							<Popover.Dropdown p={0}>
								<Stack p={4} w={256}>
									<Group px={8} py={6} position="apart">
										<Group spacing={8} align="center">
											<Icon name="archive" />
											<Text size="sm">Show archived teams</Text>
										</Group>
										<Switch
											checked={includeArchive}
											onChange={toggleIncludeArchive}
										/>
									</Group>
								</Stack>
							</Popover.Dropdown>
						</Popover>
					</Guard>
					<Guard v1AllowedRoles={[UserRole.ADMIN]} v2Permission="Teams.Create">
						<Button onClick={openCreateTeamModal}>New team</Button>
					</Guard>
				</NavBarRightSideWrapper>
			</NavBarWrapper>
			<NewTeamModal
				opened={createTeamModalOpened}
				onClose={closeCreateTeamModal}
				onFinish={noop}
			/>
		</>
	);
}

const ObservedTeamsPageNavBar = observer(TeamsPageNavBar);
export default ObservedTeamsPageNavBar;
